import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:7999/api' : '/api', // 后端API地址（生产环境使用相对路径，通过Nginx反向代理）
  timeout: 15000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('API响应:', res)
    // 后端返回格式: { success, message, code, result }
    if (res.code !== 200 && res.code !== 0) {
      console.error('响应错误:', res.message || 'Error')
      return Promise.reject(new Error(res.message || 'Error'))
    }
    // 将 result 字段映射为 data，保持前端代码一致
    return {
      code: res.code,
      data: res.result,
      message: res.message
    }
  },
  error => {
    console.error('响应错误:', error.message)
    if (error.response) {
      console.error('HTTP状态码:', error.response.status)
      console.error('错误详情:', error.response.data)
    }
    return Promise.reject(error)
  }
)

export default service
